import React, { useEffect } from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import '../../css/table.css';
import { Grid, Button } from '@mui/material';
import { get, isEmpty } from 'lodash';
import { getComparator, stableSort, TableComponent } from '../../Common/Table';
import FullScreenLoader from '../Loader/FullScreenLoader';
import { useNavigate } from 'react-router';
import { useState } from 'react';
import { postRequest, deleteRequest } from '../interceptor/interceptor';
import { toast } from 'react-toastify';
import DeleteModal from '../../Common/DeleteModal';
import { MdDelete } from 'react-icons/md';
import { FaEdit } from 'react-icons/fa';
import { GET_USERS, DELETE_USER } from '../../apiConst';

import { useForm } from 'react-hook-form';
import SelectDropdown from '../../Common/SelectDropdown';
import { userTableHeader } from '../../Fields/userFields';
import { useMediaQuery } from 'react-responsive';
import TableCard from '../../Common/TableCard';
import { IoMdAdd } from 'react-icons/io';
import { useSelector } from 'react-redux';


export default function UserDetails() {
  const isTabletMid = useMediaQuery({ query: '(max-width: 768px)' });
  const [order, setOrder] = useState('asc');
  const [tableRowsData, setTableRowsData] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [selected, setSelected] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchVal, setSearchVal] = useState('');
  const [totalCount, setTotalCount] = useState(rowsPerPage);
  const headers = userTableHeader;
  const [modal, setModal] = useState(false);
  const [dataId, setDataId] = useState('');
  const { email, role } = useSelector((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);

  let navigate = useNavigate();

  const getAllData = (pg = 1, size = 10, search = '', searchKey = null) => {
    setIsLoading(true);
    let payload = {
      filter: {},
      sortOrder: -1,
      page: pg,
      pageSize: size,
    };
    const { searchField } = getValues();
    const key = searchKey ? searchKey : searchField;
    if (key && search) {
      payload = {
        ...payload,
        filter: { ...payload.filter, [key]: search },
      };
    }
    console.log('payload', payload);
    postRequest(
      `${GET_USERS}
      `,
      payload
    )
      .then((res) => {
        const result = res.data.result;
        const total = res.data.totalCount;
        if (result) {
          console.log(result);
          setTableRowsData(result);
          setIsLoading(false);
          setTotalCount(total);
        } else {
          setIsLoading(false);
          setTotalCount(0);
          setTableRowsData([]);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleClick = (event, row) => {
    setSelected(row);
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    getAllData(Number(newPage + 1), rowsPerPage, '');
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    getAllData(1, parseInt(event.target.value), '');
  };

  useEffect(() => {
    getAllData();
  }, []);

  const {
    register,
    getValues,
    formState: { errors },
  } = useForm({});

  const handleSearchFieldDropdown = (e) => {
    if (searchVal) {
      getAllData(1, rowsPerPage, searchVal, e.target.value);
    }
  };

  const componentDisplay = () => {
    const cells = headers?.filter((cell) => cell.id !== 'action'&&cell.id !== 'sno');
    return (
      <div className="lg:mr-3 lg:w-52 text-center mb-[-15px] w-48">
        <DeleteModal
          dataId={dataId}
          firstButtonText={'Cancel'}
          secondButtonText={'Delete'}
          heading={'Confirm Delete'}
          body={<p>Do you want to remove the user?</p>}
          modal={modal}
          pressSecondButton={(id) => onDelete(id)}
          pressFirstButton={() => setModal(false)}
          pressCloseButton={() => setModal(false)}
        />
        {headers.length > 0 && (
          <SelectDropdown
            fieldName="searchField"
            options={cells}
            optionsLabelKey="label"
            optionsValueKey="id"
            register={register}
            onChange={handleSearchFieldDropdown}
            errors={errors}
            fieldType="select"
            className="min-h-[auto] ml-2 w-full border-1 bg-light py-2 text-sm text-gray-900 bg-white-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
            emptyOption={false}
          />
        )}
      </div>
    );
  };

  const onEdit = (row, e) => {
    e.preventDefault();
    navigate('/add-user', {
      state: {
        data: row,
        isEdit: true,
      },
    });
  };

  const onDelete = (id) => {
    console.log('id: ' + id);
    setIsLoading(true);
    deleteRequest(`${DELETE_USER}${id}`)
      .then((res) => {
        setModal(false);
        setIsLoading(false);
        toast.success('User Deleted Successfully');
        getAllData();
      })
      .catch((error) => {
        setModal(false);
        console.log('error', error);
        setIsLoading(false);
      });
  };
  const openModal = (item) => {
    setModal(true);
    setDataId(item?.userId);
  };
  return (
    <React.Fragment>
      {isLoading && <FullScreenLoader />}
      <div className="m-4 flex justify-end">
        {['Super-Admin'].includes(role) && (
          <Button
            variant="contained"
            // color="primary"
            onClick={() => navigate('/add-user')}
            className="mt-2 w-full md:w-48  bg-blueBg hover:bg-blueBg"
            startIcon={<IoMdAdd />}
          >
            Add User
          </Button>
        )}
      </div>
      <div className="taskList mx-2 shadow-lg bg-white rounded-lg mt-2 p-3">
        {isTabletMid ? (
          <div>
            <div className="grid grid-cols-1 pt-2 pb-2">
              <TableComponent
                numSelected={isEmpty(selected) ? 0 : 1}
                searchVal={searchVal}
                headingText={'Users'}
                order={order}
                searchBar={true}
                orderBy={orderBy}
                rowCount={tableRowsData.length || 0}
                tableRowsData={tableRowsData}
                selected={selected}
                headCells=""
                setOrder={setOrder}
                setOrderBy={setOrderBy}
                setSearchVal={setSearchVal}
                rowsPerPage={rowsPerPage}
                getAllData={getAllData}
                componentDisplay={componentDisplay}
              >
                {tableRowsData &&
                  tableRowsData.length > 0 &&
                  tableRowsData.map((data) => (
                    <TableCard
                      key={data.userId}
                      id={data.userId}
                      firstName={data.firstName}
                      lastName={data.lastName}
                      allowedRoles={['Super-Admin']}
                      role={role}
                      onEdit={
                        (e) =>
                          // role === "Super-Admin" && data.email !== email
                          //   ?
                          onEdit(data, e)
                        // : null
                      }
                      onDelete={() =>
                        role === 'Super-Admin' && data.email !== email
                          ? openModal(data)
                          : null
                      }
                      userRole={data.role}
                      email={data.email}
                      contactNo={data.contactNo}
                    />
                  ))}
              </TableComponent>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={'Entries per page: '}
                labelDisplayedRows={({ from, to, count }) =>
                  `Showing ${from}-${to} of ${count} entries`
                }
              />
            </div>
          </div>
        ) : (
          <div style={{ width: '100%' }}>
            <TableComponent
              numSelected={0}
              searchVal={searchVal}
              headingText={'Users'}
              order={order}
              searchBar={true}
              orderBy={orderBy}
              rowCount={tableRowsData.length || 0}
              tableRowsData={tableRowsData}
              headCells={headers}
              setOrder={setOrder}
              setOrderBy={setOrderBy}
              setSearchVal={setSearchVal}
              rowsPerPage={rowsPerPage}
              getAllData={getAllData}
              componentDisplay={componentDisplay}
            >
              <TableBody className="table-body">
                {tableRowsData &&
                  tableRowsData.length > 0 &&
                  stableSort(tableRowsData, getComparator(order, orderBy)).map(
                    (row, index) => {
                      return (
                        <TableRow
                          hover
                          onClick={(event) => handleClick(event, row)}
                          role="radio"
                          name="selectedRow"
                          tabIndex={-1}
                          key={index}
                        >
                         

                          {headers.map((cell) => {
                            return (
                              <TableCell key={cell.id + index} className={cell.id === 'sno' ? 'sno-column' : ''}>
                                {cell.id === 'action' ? (
                                  <div className="justify-center items-center flex">
                                    <div
                                      onClick={(e) =>
                                        role === 'Super-Admin'
                                          ? onEdit(row, e)
                                          : null
                                      }
                                    >
                                      <FaEdit
                                        size={20}
                                        disabled={
                                          role !== 'Super-Admin' ||
                                          row.email === email
                                        }
                                        className={`hover:cursor-pointer ${
                                          role === 'Super-Admin'
                                            ? 'text-blue-800'
                                            : 'text-gray-600'
                                        }`}
                                      />
                                    </div>

                                    <div
                                      onClick={(e) =>
                                        role === 'Super-Admin' &&
                                        row.email !== email
                                          ? openModal(row)
                                          : null
                                      }
                                    >
                                      <MdDelete
                                        size={25}
                                        disabled={
                                          role !== 'Super-Admin' ||
                                          row.email === email
                                        }
                                        className={`hover:cursor-pointer ${
                                          role === 'Super-Admin' &&
                                          row.email !== email
                                            ? 'text-red-800'
                                            : 'text-gray-600'
                                        }`}
                                      />
                                    </div>
                                  </div>
                                ) : cell.id === 'sno' ? (
                                  index + 1
                                ) : cell.id === 'firstName' ? (
                                  get(row, 'firstName') +
                                  ' ' +
                                  get(row, 'lastName')
                                ) : (
                                  get(row, cell.id)
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    }
                  )}
              </TableBody>
            </TableComponent>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={'Entries per page: '}
              labelDisplayedRows={({ from, to, count }) =>
                `Showing ${from}-${to} of ${count} entries`
              }
            />
          </div>
        )}
      </div>
     
    </React.Fragment>
  );
}
